const languageKey = 'language-issue';
export const getLanguage = () => localStorage.getItem(languageKey);
export const setLanguage = (language: string) => localStorage.setItem(languageKey, language);

// App
const sidebarStatusKey = 'sidebar_status-issue';
export const getSidebarStatus = () => localStorage.getItem(sidebarStatusKey);
export const setSidebarStatus = (sidebarStatus: string) => localStorage.setItem(sidebarStatusKey, sidebarStatus);

const sizeKey = 'size-issue';
export const getSize = () => localStorage.getItem(sizeKey);
export const setSize = (size: string) => localStorage.setItem(sizeKey, size);

// 更新弹窗信息
const gearReleaseData='gearReleaseData';
export const getGearReleaseData = () => localStorage.getItem(gearReleaseData);
export const setGearReleaseData = (data: any) => localStorage.setItem(gearReleaseData, data);